module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/mediame_signup-271f468633f8b7b353cdd9468b40d3b1.svg";